/** US phone helpers — display as (XXX) XXX-XXXX, store normalized the same way. */

export function digitsOnly(value: string): string {
  return value.replace(/\D/g, "");
}

/** Format up to 10 digits as the user types. */
export function formatUsPhoneInput(raw: string): string {
  const d = digitsOnly(raw).slice(0, 10);
  if (d.length === 0) return "";
  if (d.length <= 3) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

export function isValidUsPhone(value: string): boolean {
  const d = digitsOnly(value);
  if (d.length !== 10) return false;
  // NANP: area code and exchange cannot start with 0 or 1.
  if (d[0] === "0" || d[0] === "1") return false;
  if (d[3] === "0" || d[3] === "1") return false;
  return true;
}

/** Returns formatted phone or null if invalid / empty. */
export function normalizeUsPhone(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) return null;
  if (!isValidUsPhone(trimmed)) return null;
  return formatUsPhoneInput(trimmed);
}

export const US_PHONE_INVALID_MSG =
  "Enter a valid 10-digit US phone number, e.g. (915) 555-0123.";

/** Mask for display, e.g. (***) ***-1234 */
export function maskUsPhone(value: string): string {
  const d = digitsOnly(value);
  if (d.length < 4) return "(***) ***-****";
  return `(***) ***-${d.slice(-4)}`;
}
